import React, { Component } from 'react'

export default class SocialAccountSkeleton extends Component {
    render() {
        return (
            <div className="card card-custom">
                <div className="card-header flex-wrap py-3 justify-content-end">
                    <div className="card-toolbar">
                        <p className="sk_rect rounded-1 m-auto" style={{width:145,height:42}}></p>
                    </div>
                </div>
                <div className="card-body p-5">
                    <div className="table-responsive">
                        <div className="accordion accordion-light accordion-svg-toggle conn_accounts_wrap" id="connectedAccounts">
                            <div className='container-fluid'>
                            <div className="connectedAccounts_thead">
                                <ul className="list-inline row">
                                    <li className="col-3">
                                        <p className="sk_line sk_line_height_14" style={{width:100}}></p>
                                    </li>
                                    <li className="col-2">
                                        <p className="sk_line sk_line_height_14" style={{width:100}}></p>
                                    </li>
                                    <li className="col-2">
                                        <p className="sk_line sk_line_height_14" style={{width:100}}></p>
                                    </li>
                                    <li className="col-2">
                                        <p className="sk_line sk_line_height_14" style={{width:100}}></p>
                                    </li>
                                    <li className="col-2">
                                        <p className="sk_line sk_line_height_14" style={{width:100}}></p>
                                    </li>
                                    <li className="col-1">
                                        <p className="sk_line sk_line_height_14" style={{width:100}}></p>
                                    </li>
                                </ul>
                            </div>
                            <div className="connectedAccounts">
                                <div className="card rounded-0">
                                    <div className="conn_table connectedAccounts_list">
                                        <div className="row align-items-center m-0">
                                            <figure className="col-3 card-header ">
                                                <div className="d-flex align-items-center justify-content-start flex-nowrap card-title collapsed py-2">
                                                    <div className="flex-shrink-0 me-3 mt-lg-0 mt-3 d-flex align-items-center">
                                                        <div className="symbol symbol-30">
                                                            <p className="sk_rect rounded-1 m-auto" style={{width:30,height:30}}></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                    </div>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <div className="d-flex align-items-center flex-nowrap">
                                                    <div className="flex-shrink-0 me-3 mt-lg-0 mt-3">
                                                        <p className="sk_rect rounded-1 m-auto rounded-circle" style={{width:35,height:35}}></p>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                    </div>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                            </figure>
                                            <figure className="col-2">
                                                <div className="d-flex align-items-center">
                                                    <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <p className="sk_rect rounded-1 my-0" style={{width:92,height:36}}></p>
                                            </figure>
                                            <figure className="col-1 text-right">
                                                <p className="sk_rect rounded-1 m-auto" style={{width:30,height:30}}></p>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                                <div className="card rounded-0">
                                    <div className="conn_table connectedAccounts_list">
                                        <div className="row align-items-center m-0">
                                            <figure className="col-3 card-header ">
                                                <div className="d-flex align-items-center justify-content-start flex-nowrap card-title collapsed py-2">
                                                    <div className="flex-shrink-0 me-3 mt-lg-0 mt-3 d-flex align-items-center">
                                                        <div className="symbol symbol-30">
                                                            <p className="sk_rect rounded-1 m-auto" style={{width:30,height:30}}></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                    </div>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <div className="d-flex align-items-center flex-nowrap">
                                                    <div className="flex-shrink-0 me-3 mt-lg-0 mt-3">
                                                        <p className="sk_rect rounded-1 m-auto rounded-circle" style={{width:35,height:35}}></p>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                    </div>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                            </figure>
                                            <figure className="col-2">
                                                <div className="d-flex align-items-center">
                                                    <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <p className="sk_rect rounded-1 my-0" style={{width:92,height:36}}></p>
                                            </figure>
                                            <figure className="col-1 text-right">
                                                <p className="sk_rect rounded-1 m-auto" style={{width:30,height:30}}></p>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                                <div className="card rounded-0">
                                    <div className="conn_table connectedAccounts_list">
                                        <div className="row align-items-center m-0">
                                            <figure className="col-3 card-header ">
                                                <div className="d-flex align-items-center justify-content-start flex-nowrap card-title collapsed py-2">
                                                    <div className="flex-shrink-0 me-3 mt-lg-0 mt-3 d-flex align-items-center">
                                                        <div className="symbol symbol-30">
                                                            <p className="sk_rect rounded-1 m-auto" style={{width:30,height:30}}></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                    </div>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <div className="d-flex align-items-center flex-nowrap">
                                                    <div className="flex-shrink-0 me-3 mt-lg-0 mt-3">
                                                        <p className="sk_rect rounded-1 m-auto rounded-circle" style={{width:35,height:35}}></p>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                    </div>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                            </figure>
                                            <figure className="col-2">
                                                <div className="d-flex align-items-center">
                                                    <p className="sk_line sk_line_height_14 my-0" style={{width:100}}></p>
                                                </div>
                                            </figure>
                                            <figure className="col-2">
                                                <p className="sk_rect rounded-1 my-0" style={{width:92,height:36}}></p>
                                            </figure>
                                            <figure className="col-1 text-right">
                                                <p className="sk_rect rounded-1 m-auto" style={{width:30,height:30}}></p>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-10 pt-10 pb-5 border-top">
                    <div className="col-sm-12 px-3">
                        <p className="font-size-sm bg-light p-3">
                            <p className="sk_line sk_line_height_14 my-0 w-100" style={{maxWidth:700}}></p>
                        </p>
                        <p className="">
                            <p className="sk_line sk_line_height_14 my-0 w-100" style={{maxWidth:500}}></p>
                        </p>
                        <div className="position-relative d-flex align-items-center flex-wrap embed_code input_copy">
                            <p className="sk_rect rounded-1" style={{maxWidth:400,height:42}}></p>
                            <div className="emebed_action ms-3">
                                <p className="sk_rect rounded-1" style={{width:68,height:42}}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
